import React, { Component } from 'react';
import { connect } from 'react-redux';

class Feedback extends Component {
  render() {
    if (!this.props.feedback) return <div />;
    return (
      <div className={"feedback-wrapper show"}>
        <h4>{this.props.feedback}</h4>
      </div>
    );
  }
};

function mapStateToProps(state){
    return { 'feedback': state.feedback };
}

export default connect(mapStateToProps)(Feedback);


// WEBPACK FOOTER //
// ./src/components/Feedback.jsx